import React from "react";
import HeroBanner from "../Components/HeroBanner/index";
import VisionMision from "../Components/VisionMission/visionandmission"
import Leadership from "../Components/Leadership/leadership"
import WhatWeValue from "../Components/WhatWeValue/whatwevalue"
import ComplianceSecurity from "../Components/ComplianceSecurity/compliancesecurity"
import CtaButton from "../Components/AboutCta/aboutCTA"
import AboutBanner from "../Components/AboutBanner/aboutbanner";

const About = () => {
    return (
        <>
            <AboutBanner />
            <VisionMision />
            <Leadership />
            {/* <WhatWeValue /> */}
            {/* <ComplianceSecurity /> */}
            <CtaButton />
            {/* <CaseStudies /> */}
        </>
    );
}

export default About;